import AboutPage from "@src/component/home/renewal/about/AboutPage";
import AboutPageMobile from "@src/component/home/renewal/about/mobile/AboutPageMobile";
import { NextPage } from "next";
import { useEffect, useState } from "react";

interface AboutProps {
	isPc: boolean;
}

const About: NextPage<AboutProps> = (props) => {
	const [isPc, setIsPc] = useState<boolean>(props.isPc);

	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth >= 1024) {
				setIsPc(true);
			} else {
				setIsPc(false);
			}
		};
		window.addEventListener("resize", handleResize);

		handleResize();

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	return <>{isPc ? <AboutPage /> : <AboutPageMobile />}</>;
};

export default About;
